import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, Renderer2, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, CtButtonComponent, CtInputTextComponent, CtMessageComponent, breakpoints, CtRecaptchaComponent, PlusAlertsService, CtAnchorComponent, CtDialogComponent, StoreService, TokenResponseModel, SpinnerService } from 'components';

const btnMetadata : any = {
    ctType: 'CtButton',
    controlProperties: {  
      hidden : false,
      listenedComponentId: "",
      listenedProperty: "",
      disabled: false,
      modelId: "",
      btnBlock: true,
      buttonText: 'GENERAR ESTADO DE CUENTA',
      buttonColor: 'Secondary',
      icon: "",
      id: `GENERAR_ESTADO_CUENTA_DEF_${0}`,
    },
    controlActions: [],
    models: []
};

const inputMetadata : any = {
    ctType: 'CtInputText',
    controlProperties: {  
      hidden : false,
      oneLineControl: false,
      disabled: false,
      modelId: "",
      readonly: false,
      required: false,
      isPassword : false,
      length: 440,
      labelValue: 'Número de Identificación personal',
      tooltipMessage: '',
      tooltipPosition: "",
      isFilterInput: false,
      placeHolder: 'Ej.: 102930921',
      id: `ID_INPUT_TEXT_DEF_${0}`,
    },
    controlActions: [],
    models: []
};

const messageMetadata : any = {
    ctType: "CtMessage",
    controlProperties: {
        actionIcon: "",
        actionText: "",
        hidden: false,
        canBeClosed: false,
        size: "large",
        style: "unicolor",
        type: "error",
        visualization: "block",
        message: "",
        title: "",
        id: `CT_MESSAGE_DEF_LOGIN_${0}`
    },
    controlActions: [],
    models: []
};

const anchorMetadata : any = {
    ctType: "CtAnchor",
    controlProperties: {
        hidden: false,
        isNewTab: true,
        link: "https://sociedaddesegurosdevida.cr/creditos",
        styleClass: "",
        id: "CtAnchor_d6168829",
        text: "Productos y servicios",
        hoverColor: "Secondary",
        textColor: "White"
    },
    controlActions: [],
    models: []
};

const recaptchaMetadata: any = {
    ctType: "CtReCaptcha",
    controlProperties: {
        hidden: false,
        siteKey: '6Le2GeUUAAAAAFG8dmbghePltd2tFX3q9VKbJlTL',
        id: `CT_RECAPTCHA_DEF_PIN_${0}`
    },

    controlActions: [],
    models: []
};

@Component({
  selector: 'app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.css']
})
export class AuthLoginComponent implements OnInit, AfterViewInit {

    //constants
    private idFormatNotValid : string = 'Identificación no válida.';
    private isFieldEmpty : string = 'Para ingresar a nuestra Sucursal Virtual es necesario que ingrese tanto el número de identificación personal como la contraseña asociada a la cuenta.';
    private userDoesNotExist : string = 'Lo sentimos, el número de identificación que digitó no corresponde a ningún usuario registrado en nuestra sucursal virtual. Por favor, valide que haya ingresado la información correctamente o considere crear una cuenta con nosotros.';
    private invalidCredentials : string = 'Lo sentimos, el usuario o la contraseña son incorrectos, revise la información ingresada e intente nuevamente.';
    private blockedUser : string = 'Lo sentimos, su cuenta de usuario ha sido bloqueada al iniciar sesión erróneamente 3 veces de manera consecutiva. Para obtener acceso a su cuenta le sugerimos utilizar el procedimiento de recuperación de contraseña.';
    private isNullFields : string = 'Asegúrate de ingresar tu identificación y completar el recaptcha.';
    private invalidCredentialsCode : string = 'FPLUS.ERR_USER_CREDENTIALS';
    private userNotFoundCode : string = 'FPLUS.INFO_USER_NOT_FOUND';
    private blockedUserCode : string = 'FPLUS.INFO_USER_LOCKED';
    private employerHasAdmin : string = 'DMZ.DMZ_PATRONO_HAS_ADMIN';
    private employerHasNoAdmin : string = 'DMZ.DMZ_PATRONO_HAS_NO_ADMIN';

    //containers / util
    @ViewChild('estadoCuentaBtn', { read: ViewContainerRef }) estadoCuentaBtnContainer: ViewContainerRef;
    @ViewChild('estadoCuentaBottomBtn', { read: ViewContainerRef }) estadoCuentaBottomBtnContainer: ViewContainerRef;
    @ViewChild('signInBtn', { read: ViewContainerRef }) signInBtnContainer: ViewContainerRef;
    @ViewChild('pinBtn', { read: ViewContainerRef }) pinBtnContainer: ViewContainerRef;
    @ViewChild('pinBottomBtn', { read: ViewContainerRef }) pinBottomBtnContainer: ViewContainerRef;
    @ViewChild('sendPinBtn', { read: ViewContainerRef }) sendPinBtnContainer: ViewContainerRef;
    @ViewChild('passwordInput', { read: ViewContainerRef }) passwordInputContainer: ViewContainerRef;
    @ViewChild('userIdInput', { read: ViewContainerRef }) idInputContainer: ViewContainerRef;
    @ViewChild('userPinDocInput', { read: ViewContainerRef }) userPinDocInputContainer: ViewContainerRef;
    @ViewChild('errorMessageContainer', { read: ViewContainerRef }) errorMessageContainer : ViewContainerRef;
    @ViewChild('recaptchaContainer', { read: ViewContainerRef }) recaptchaContainer : ViewContainerRef;
    @ViewChild('dialogContainer', { read: ViewContainerRef }) dialogContainer : ViewContainerRef;
    @ViewChild('errorFieldsContainer', { read: ViewContainerRef }) errorFieldsContainer: ViewContainerRef;
    @ViewChild('anchorContainer', { read: ViewContainerRef }) anchorContainer: ViewContainerRef;
    @ViewChild('sendEstCuenta', { read: ViewContainerRef }) sendEstCuentaBtnContainer: ViewContainerRef;
    @ViewChild('userEstCuentaIdInput', { read: ViewContainerRef }) userIdEstCuentaInputContainer: ViewContainerRef;
    @ViewChild('recaptchaContainerEstCuenta', { read: ViewContainerRef }) recaptchaEstCuentaContainer : ViewContainerRef;

    @ViewChild('helpCenterBtn', { read: ViewContainerRef }) helpCenterBtnContainer: ViewContainerRef;
    @ViewChild('helpCenterBottomBtn', { read: ViewContainerRef }) helpCenterBottomBtnContainer: ViewContainerRef;

    //properties
    public closeIconPath : string = 'assets/icons/close.svg';
    private width : number = 500;
    public hasAccount: string;
    public tipMedioContacto: string;
    public medioContacto: string;
    public isCorreo : boolean = false;
    public isSMS : boolean = false;
    public medioContactoSMS: string;
    public medioContactoCorreo: string;
    public messageDescription: string;
    private userDocId: string;

    //components
    private genEstCuentaBtn : CtButtonComponent;
    private pinBtn : CtButtonComponent;
    private signInBtn : CtButtonComponent;
    private sendPinBtn : CtButtonComponent;
    private sendEstCuentaBtn : CtButtonComponent;
    private passwordInput : CtInputTextComponent;
    private userIdInput : CtInputTextComponent;
    private userEstCuentaInput : CtInputTextComponent;
    private userPinDocInput : CtInputTextComponent;
    private pinCtDialog : CtDialogComponent;
    private captchaComponent: CtRecaptchaComponent;
    private captchaComponentEstCuenta : CtRecaptchaComponent;

    private helpCenterBtn : CtButtonComponent;


    //util
    public errorHandler: any;
    public form: any;
    public isSmall : boolean = false;
    public isMedium : boolean = false;
    public isExtraSmall : boolean = false; 
    private isOpen : boolean = false;
    public errorMessage : string = '';
    public canBeClosed : boolean = true;
    public errorToDisplay = null;
    public errorFields : string = '';
    public isEstCuentPopUpOpen : boolean = false;
    public socialMediaVisiable : boolean = false;

    //subscription variables
    private captchaValue : boolean;
    private estCuentaCaptcha : boolean;
    private inputSendPin : string;
    private inputEstCuenta : string;

    constructor(private cfr : ComponentFactoryResolver,
        private authService : AuthService, 
        private router : Router,
        private renderer : Renderer2,
        private plusAlertService: PlusAlertsService,
        private cdf: ChangeDetectorRef,
        private storeService: StoreService,
        private spinnerService : SpinnerService) {}

    ngOnInit(): void {
        this.onResize();
    }

    /**
     * The ngAfterViewInit function builds buttons and inputs after a JS loop
     */
    public ngAfterViewInit() {
        setTimeout(() => {
            this.buildButtons();
            this.buildInputs();
            this.createComponent(this.anchorContainer, CtAnchorComponent, anchorMetadata);
        });
    }

    //create a hostlistener for the window width
    @HostListener('window:resize', ['$event'])
    onResize() {
      this.manageWindowResizing();
      this.postResizeActions();
    }

    /**
     * The function manages window resizing
    */
    private manageWindowResizing() {
        const innerWidth : number = window.innerWidth;
        this.isMedium = innerWidth >= breakpoints.L;
        this.isSmall = innerWidth < breakpoints.L && innerWidth > breakpoints.M;
        this.isExtraSmall = (innerWidth <= breakpoints.M && innerWidth > breakpoints.S) || innerWidth <= breakpoints.S;
    }

    private postResizeActions() : void {
        this.cdf.detectChanges();
        this.manageButtonResizing();
        this.manageSignButton();
        if(this.isOpen){
            this.manageSendPinButton();
            this.manageHelpCenterButton();
        }  
    }

    private manageButtonResizing(): void {
        this.manageEstCuentaBtnRender();
        this.manageEstCuentaBottom();
        this.manageGenEstCuentaHeader();
        this.manageGenPinBtnRender();
        this.manageGenPinBottom();
        this.manageGenPinHeader();

        this.manageHelpCenterBtnRender();
        this.manageHelpCenterBottom();
        this.manageHelpCenterHeader();
    }

    /**
     * manages the rendering of a button based on the screen size.
     */
    private manageEstCuentaBtnRender() {
        if(this.genEstCuentaBtn && this.isExtraSmall) this.genEstCuentaBtn = null;
        if(!this.genEstCuentaBtn && !this.isExtraSmall){
          setTimeout(() => {
              this.buildButtons();
              this.createComponent(this.anchorContainer, CtAnchorComponent, anchorMetadata);
          })
        }
    }

    private manageGenEstCuentaHeader() {
        if(!this.estadoCuentaBottomBtnContainer && !this.isExtraSmall && this.estadoCuentaBtnContainer){
            setTimeout(() => {
                this.buildButtons();
                this.createComponent(this.anchorContainer, CtAnchorComponent, anchorMetadata);
            });
        } 
    }

    /**
     * Creates "Generar estado de cuenta" for the bottom section of the screen when is extra small
     */
    private manageEstCuentaBottom() {
        if(!this.genEstCuentaBtn && this.isExtraSmall){
            setTimeout(() => {
                this.genEstCuentaBtn = this.createComponent(this.estadoCuentaBottomBtnContainer,CtButtonComponent,btnMetadata);
                this.createComponent(this.anchorContainer, CtAnchorComponent, anchorMetadata);
                this.genEstCuentaBtn.clickTimer.subscribe((ev : Event) => {
                    this.genEstadoCuenta();
                });
            })
        }
    }

    /**
     * manages the rendering of a button based on the screen size.
     */
    private manageGenPinBtnRender() {
        if(this.pinBtn && this.isExtraSmall) this.pinBtn = null;
        if(!this.pinBtn && !this.isExtraSmall){
            setTimeout(() => {
                this.buildButtonsPopUp();
            })
        }
    }

    private manageGenPinHeader() {
        if(!this.pinBottomBtnContainer && !this.isExtraSmall && this.pinBtnContainer){
            setTimeout(() => {
                this.buildButtonsPopUp();
            });
        } 
    }

    /**
     * Creates "Generar estado de cuenta" for the bottom section of the screen when is extra small
     */
    private manageGenPinBottom() {
        if(!this.pinBtn && this.isExtraSmall){
            setTimeout(() => {

                let pinButtonMetaData = JSON.parse(JSON.stringify(btnMetadata));
                pinButtonMetaData.controlProperties.id = `GEN_PIN__DEF_${0}`;
                pinButtonMetaData.controlProperties.buttonText = 'GENERAR PIN';
                pinButtonMetaData.controlProperties.buttonColor = 'Secondary';

                this.pinBtn = this.createComponent(this.pinBottomBtnContainer,CtButtonComponent,pinButtonMetaData);
                this.pinBtn.clickTimer.subscribe((ev : Event) => {
                    this.openPopUp();
                });
            })
        }
    }

        /**
     * manages the rendering of a button based on the screen size.
     */
        private manageHelpCenterBtnRender() {
            if(this.helpCenterBtn && this.isExtraSmall) this.helpCenterBtn = null;
            if(!this.helpCenterBtn && !this.isExtraSmall){
                setTimeout(() => {
                    this.buildButtonHelpCenterPopUp();
                })
            }
        }
    
        private manageHelpCenterHeader() {
            if(!this.helpCenterBottomBtnContainer && !this.isExtraSmall && this.helpCenterBtnContainer){
                setTimeout(() => {
                    this.buildButtonHelpCenterPopUp();
                });
            } 
        }
    
        /**
         * Creates "Generar estado de cuenta" for the bottom section of the screen when is extra small
         */
        private manageHelpCenterBottom() {
            if(!this.helpCenterBtn && this.isExtraSmall){
                setTimeout(() => {
    
                    let helpCenterButtonMetaData = JSON.parse(JSON.stringify(btnMetadata));
                    helpCenterButtonMetaData.controlProperties.id = `HELP_CENTER__DEF_${0}`;
                    helpCenterButtonMetaData.controlProperties.buttonText = 'CENTRO DE AYUDA';
                    helpCenterButtonMetaData.controlProperties.buttonColor = 'Secondary';
    
                    this.helpCenterBtn = this.createComponent(this.helpCenterBottomBtnContainer,CtButtonComponent,helpCenterButtonMetaData);
                    this.helpCenterBtn.clickTimer.subscribe((ev : Event) => {
                        localStorage.setItem('isLogged','false');
                        this.router.navigate(['/help-center']);
                    });
                })
            }
        }

    private manageSendPinButton(): void {
        if(this.isExtraSmall && this.sendPinBtn){
            this.sendPinBtn.setBtnBlock(true);
        } else {
            if(!this.sendPinBtn) return;
            this.sendPinBtn.setBtnBlock(false);
            this.sendPinBtn.setWidth(200);
        }
    }

    private manageHelpCenterButton(): void {
        if(this.isExtraSmall && this.helpCenterBtn){
            this.helpCenterBtn.setBtnBlock(true);
        } else {
            if(!this.helpCenterBtn) return;
            this.helpCenterBtn.setBtnBlock(false);
            this.helpCenterBtn.setWidth(200);
        }
    }

    /**
     * manages the sign-in button's block and width based on the screen size.
     */
    private manageSignButton(): void {
        if(this.isExtraSmall && this.signInBtn){
            this.signInBtn.setBtnBlock(true);
        } else {
            if(!this.signInBtn) return;
            this.signInBtn.setBtnBlock(false);
            this.signInBtn.setWidth(440);
        }
    }

    public genEstadoCuenta(): void {
        this.isEstCuentPopUpOpen = true;
        this.cdf.detectChanges();

        this.renderer.setStyle(document.body, 'overflow', 'hidden');

        let sendEstCuentaBtnMetadata = JSON.parse(JSON.stringify(btnMetadata));
        sendEstCuentaBtnMetadata.controlProperties.id = `OPEN_ESTCUENTA_DEF_${0}`;
        sendEstCuentaBtnMetadata.controlProperties.buttonText = 'Enviar';
        sendEstCuentaBtnMetadata.controlProperties.buttonColor = 'Primary';
        sendEstCuentaBtnMetadata.controlProperties.disabled = true;

        const userIdEstCuentaInput = JSON.parse(JSON.stringify(inputMetadata));
        userIdEstCuentaInput.controlProperties.id = `DOC_EST_INPUT_DEF_${0}`;
        userIdEstCuentaInput.controlProperties.placeHolder = 'Ingresar numero de identificación';
        userIdEstCuentaInput.controlProperties.labelValue = 'Número de identificación personal';

        this.sendEstCuentaBtn = this.createComponent(this.sendEstCuentaBtnContainer, CtButtonComponent, sendEstCuentaBtnMetadata);
        this.sendEstCuentaBtn.clickTimer.subscribe((ev : Event) => {
            if(this.sendEstCuentaBtn.getDisabled()){
                return;
            }
            this.sendEstCuenta();
        })

        let recaptchaMeta = JSON.parse(JSON.stringify(recaptchaMetadata));
        this.captchaComponentEstCuenta = this.createComponent(this.recaptchaEstCuentaContainer,CtRecaptchaComponent,recaptchaMeta);
        this.cdf.detectChanges();
        this.captchaComponentEstCuenta.isValidChange$.subscribe(isValid => {
            this.estCuentaCaptcha = isValid;
            if(!this.userEstCuentaInput) return;
            if(this.inputEstCuenta.length > 0 && this.estCuentaCaptcha){
                this.sendEstCuentaBtn.setDisabled(false);
            } else {
                this.sendEstCuentaBtn.setDisabled(true);
            }
        }); 
        
        this.userEstCuentaInput = this.createComponent(this.userIdEstCuentaInputContainer, CtInputTextComponent,userIdEstCuentaInput);
        this.cdf.detectChanges();
        if(this.userEstCuentaInput.DomElement){
            this.renderer.listen(this.userEstCuentaInput.DomElement, 'input', (event) => {
                this.inputEstCuenta = event.target.value;
                if(this.inputEstCuenta.length > 0 && this.estCuentaCaptcha){
                    this.sendEstCuentaBtn.setDisabled(false);
                } else {
                    this.sendEstCuentaBtn.setDisabled(true);
                }
            });
        }
    }

    private sendEstCuenta(): void {
        this.authService.sendUnauthenticatedEstCuenta(this.inputEstCuenta).subscribe({
            next: (result : any) => {
                this.inputEstCuenta = '';
                this.closeEstCuentaPopup();
                this.pinCtDialog = this.plusAlertService.setCtDialogInfo('Estado de cuenta enviado', 'success', 'success', 'primary',
                result.ResponseMessages[0].Message,
                true, 'Finalizar', 'Cancelar', this.dialogContainer);
                this.managePopUpButtonActions();
            },
            error: (err : any) => {
                this.closeEstCuentaPopup();
                this.inputEstCuenta = '';
                console.log(err);
                this.pinCtDialog = this.plusAlertService.setCtDialogInfo('Estado de cuenta no se pudo enviar ', 'error', 
                'error', 'primary', err.description,
                true, 'Finalizar', 'Cancelar',this.dialogContainer);
                this.managePopUpButtonActions();
            }
        });
       
    }

    /**
     * Executes after the user click and handles the sign-in process by disabling the sign-in button, validating user input,
     * executing the sign-in, and enabling the sign-in button.
     */
    public signIn(): void {
        if(!this.passwordInput.getValue() && !this.userIdInput.getValue()) return;
        this.signInBtn.setDisabled(true);
        this.errorMessage = '';
        let userIdTemp : string = this.userIdInput.getValue().replace(/-/g, '');
        if(userIdTemp[0] === '0') userIdTemp = userIdTemp.substring(1); 
        const passwordTemp : string = this.passwordInput.getValue();
        if(!this.validateUserInput(userIdTemp, passwordTemp)) return;

        this.executeSignIn(userIdTemp, passwordTemp);
        this.signInBtn.setDisabled(false);
    }

    /**
     * executes a sign-in process
     * @param {string} userId - string
     * @param {string} password - string
     */
  private executeSignIn(userId: string, password: string): void {
    this.authService.logIn(userId, password).subscribe({
      next: (token : any) => {
        //this.validateIfUserIsEmployer(userId, password, token);
        this.router.navigate(['/home']);
      },
      error : (err : any) => {
        if(err.error_code === this.invalidCredentialsCode) this.errorMessage = this.invalidCredentials;
        else if (err.error_code === this.userNotFoundCode) this.errorMessage = this.userDoesNotExist;
        else if (err.error_code === this.blockedUserCode) this.getBlockedUserMessage(userId);
        else this.errorMessage = err.message;
        this.buildMessage();
        this.signInBtn.setDisabled(false);
      }
    })
  }

    private getBlockedUserMessage(userId : string): void {
        this.authService.getLoginPreviewInfo(userId).subscribe({
            next : () => {
                this.errorMessage = this.blockedUser;
                this.buildMessage();
                this.signInBtn.setDisabled(false); 
            },
            error : (err : any) => {
                if(err.error_code === this.employerHasAdmin){
                    this.errorMessage = err.description;
                } else {
                    this.errorMessage = this.blockedUser;
                }
                this.buildMessage();
                this.signInBtn.setDisabled(false); 
            }
        });
    }
    
    private validateIfUserIsEmployer(userId : string, password : string, token : string): void {
        this.authService.getLoginPreviewInfo(userId).subscribe({
            next : () => {
                this.storeService.setState('userPreviewData', {userId, password});
                this.router.navigate(['/login/mfa']);
            },
            error : (err : any) => {
                if(err.error_code === this.employerHasAdmin){
                    this.errorMessage = err.message;
                    this.buildMessage();
                    this.signInBtn.setDisabled(false); 
                }
                else if (err.error_code === this.employerHasNoAdmin) {
                    this.storeService.setState('tmpToken',token);
                    this.storeService.setState('idPatrono', userId);
                    this.router.navigate(['/assign-administrator']);
                }
            }
        });
    }

    /**
     * validates user input for a user ID and password, checking for empty fields and a valid ID format.
     * @param {string} userId
     * @param {string} password
     */
    private validateUserInput(userId : string, password : string): boolean {

        if(!userId || !password){
            this.errorMessage = this.isFieldEmpty;
            this.buildMessage();
            this.signInBtn.setDisabled(false);
            return false;
        }
        return true;
    }

       /**
     * validates user input for a user ID, checking for empty fields and a valid ID format.
     * @param {string} userDocId
     */
       private validateDocPinInput(userDocId : string): boolean {

        if(!userDocId){
            this.errorFields = this.isNullFields;
            this.buildDocPinMessage();
            this.sendPinBtn.setDisabled(false);
            return false;
        }
        return true;
    }

    /**
     * Handles button creation and subscrition to onClick event
     */
    private buildButtons() {
        let signInButtonMetadata = JSON.parse(JSON.stringify(btnMetadata));
        signInButtonMetadata.controlProperties.id = `SIGN_IN_DEF_${0}`;
        signInButtonMetadata.controlProperties.buttonText = 'INICIAR';
        signInButtonMetadata.controlProperties.buttonColor = 'Primary';
        this.createButtons(btnMetadata, signInButtonMetadata);
    }

    /**
     * subscribes to their click events to perform actions.
     * @param {any} genEstCuentaBtnMetadata
     * @param {any} signInButtonMetadata
     */
    private createButtons(genEstCuentaBtnMetadata : any, signInButtonMetadata : any ): void {
        if(this.estadoCuentaBtnContainer){
            this.genEstCuentaBtn = this.createComponent(this.estadoCuentaBtnContainer, CtButtonComponent, genEstCuentaBtnMetadata);
        } else {
            this.genEstCuentaBtn = this.createComponent(this.estadoCuentaBottomBtnContainer, CtButtonComponent, genEstCuentaBtnMetadata);
            this.createComponent(this.anchorContainer, CtAnchorComponent, anchorMetadata);
        }
        this.genEstCuentaBtn.clickTimer.subscribe((ev : Event) => {
            this.genEstadoCuenta();
        });  
        this.signInBtn = this.createComponent(this.signInBtnContainer, CtButtonComponent, signInButtonMetadata);
        this.signInBtn.clickTimer.subscribe((ev : Event) => {
            this.signIn();
        })
    }

    /**
     * builds input fields
     */
    private buildInputs() {
        const passwordInputMedatada = JSON.parse(JSON.stringify(inputMetadata));
        passwordInputMedatada.controlProperties.id = `PASSWORD_INPUT_DEF_${0}`;
        passwordInputMedatada.controlProperties.placeHolder = 'Digite su contraseña';
        passwordInputMedatada.controlProperties.labelValue = 'Contraseña';
        passwordInputMedatada.controlProperties.isPassword = true;
        this.createInputs(inputMetadata, passwordInputMedatada);
    }

    private buildMessage(): void {
        messageMetadata.controlProperties.message = this.errorMessage;
        setTimeout(() => {
            this.createComponent(this.errorMessageContainer, CtMessageComponent, messageMetadata);    
        });
    }

    private buildDocPinMessage(): void {
        messageMetadata.controlProperties.message = this.errorFields;
        setTimeout(() => {
            this.createComponent(this.errorFieldsContainer, CtMessageComponent, messageMetadata);    
        });
    }

    /**
     * The function creates input components 
     * @param {any} idInput - Metadata
     * @param {any} passwordInput - Metadata
     */
    private createInputs(idInput : any, passwordInput : any): void {
        this.userIdInput = this.createComponent(this.idInputContainer, CtInputTextComponent, idInput);
        this.passwordInput = this.createComponent(this.passwordInputContainer, CtInputTextComponent, passwordInput);
        this.passwordInput.enterPressed$.subscribe(() => {
            this.signIn();
        });
    }

    private buildInputsPopUp() {
        const userPinDocInputMetadata= JSON.parse(JSON.stringify(inputMetadata));
        userPinDocInputMetadata.controlProperties.id = `DOC_INPUT_DEF_${0}`;
        userPinDocInputMetadata.controlProperties.placeHolder = 'Ingresar numero de identificación';
        userPinDocInputMetadata.controlProperties.labelValue = 'Número de identificación personal';
        this.createInputsPopUp(userPinDocInputMetadata);
    }

    /**
     * Handles button creation and subscrition to onClick event
     */
    private buildButtonsPopUp() {
        let pinButtonMetaData = JSON.parse(JSON.stringify(btnMetadata));
        pinButtonMetaData.controlProperties.id = `GEN_PIN__DEF_${0}`;
        pinButtonMetaData.controlProperties.buttonText = 'GENERAR PIN';
        pinButtonMetaData.controlProperties.buttonColor = 'Secondary';
        pinButtonMetaData.controlProperties.width = 250;

        this.createButtonsPopUp(pinButtonMetaData);
    }

        /**
     * Handles button creation and subscrition to onClick event
     */
        private buildButtonHelpCenterPopUp() {
            let helpCenterButtonMetaData = JSON.parse(JSON.stringify(btnMetadata));
            helpCenterButtonMetaData.controlProperties.id = `HELP_CENTER__DEF_${0}`;
            helpCenterButtonMetaData.controlProperties.buttonText = 'CENTRO DE AYUDA';
            helpCenterButtonMetaData.controlProperties.buttonColor = 'Secondary';
            helpCenterButtonMetaData.controlProperties.width = 250;
    
            this.createButtonPopUp(helpCenterButtonMetaData);
        }
    


    /**
     * subscribes to their click events to perform actions.
     * @param {any} helpCenterButtonMetaData
     */
    private createButtonsPopUp(pinButtonMetaData : any): void {
       
        if(this.pinBtnContainer){
            this.pinBtn = this.createComponent(this.pinBtnContainer, CtButtonComponent, pinButtonMetaData);
        } else {
            this.pinBtn = this.createComponent(this.pinBottomBtnContainer, CtButtonComponent, pinButtonMetaData);
        }
        this.pinBtn.clickTimer.subscribe((ev : Event) => {
            this.openPopUp();
        });

    }

    

    /**
     * subscribes to their click events to perform actions.
     * @param {any} helpCenterButtonMetaData
     */
    private createButtonPopUp(helpCenterButtonMetaData : any): void {
       
        if(this.helpCenterBtnContainer){
            this.helpCenterBtn= this.createComponent(this.helpCenterBtnContainer, CtButtonComponent, helpCenterButtonMetaData);
        } else {
            this.helpCenterBtn = this.createComponent(this.helpCenterBottomBtnContainer, CtButtonComponent, helpCenterButtonMetaData);
        }
        this.helpCenterBtn.clickTimer.subscribe((ev : Event) => {
            localStorage.setItem('isLogged','false');
            this.router.navigate(['/help-center']);
        });
    }

    /**
     * The function creates input components 
     * @param {any} userIdDocInput - Metadata
     */
    private createInputsPopUp(userIdDocInput : any): void {//, userIdDocInput : any
        this.userPinDocInput = this.createComponent(this.userPinDocInputContainer, CtInputTextComponent,userIdDocInput);
        this.cdf.detectChanges();
        if(this.userPinDocInput.DomElement){
            this.renderer.listen(this.userPinDocInput.DomElement, 'input', (event) => {
                this.inputSendPin = event.target.value;
                if(this.inputSendPin.length > 0 && this.captchaValue){
                    this.sendPinBtn.setDisabled(false);
                } else {
                    this.sendPinBtn.setDisabled(true);
                }
            });
        }
    }

    /**
     * This function creates a component and sets its metadata in a given container.
     * @param {ViewContainerRef} container - reference to the container where the component will be created.
     * @param {any} componentReference - The component class reference
     * @param {any} metadata - s data that will be passed to the component being created.
     */
    private createComponent(container : ViewContainerRef, componentReference : any, metadata: any) {
        container.clear();
        const componentFactory = this.cfr.resolveComponentFactory(componentReference);
        const componentRef = container.createComponent(componentFactory);
        const component : any = componentRef.instance;
        component.setMetaData(metadata);
        return component;
    }

    public openPopUp(): void {
        this.isOpen = true;
        setTimeout(() => {
        this.buildInputsPopUp();

        let sendPinButtonMetaData = JSON.parse(JSON.stringify(btnMetadata));
        sendPinButtonMetaData.controlProperties.id = `SEND_PIN_DEF_${0}`;
        sendPinButtonMetaData.controlProperties.buttonText = 'Enviar';
        sendPinButtonMetaData.controlProperties.buttonColor = 'Primary';
        sendPinButtonMetaData.controlProperties.disabled = true;
        this.sendPinBtn = this.createComponent(this.sendPinBtnContainer, CtButtonComponent, sendPinButtonMetaData);
        this.sendPinBtn.clickTimer.subscribe((ev : Event) => {
            if(this.sendPinBtn.getDisabled()){
                return;
            }
            this.sendPin();
        })

        let recaptchaMeta = JSON.parse(JSON.stringify(recaptchaMetadata));

        this.captchaComponent = this.createComponent(this.recaptchaContainer,CtRecaptchaComponent,recaptchaMeta);
        this.captchaComponent.isValidChange$.subscribe(isValid => {
            this.captchaValue = isValid;
            if(!this.inputSendPin) return;
            if(this.inputSendPin.length > 0 && this.captchaValue){
                this.sendPinBtn.setDisabled(false);
            } else {
                this.sendPinBtn.setDisabled(true);
            }
          });
        }); 
        
        this.renderer.setStyle(document.body, 'overflow', 'hidden');
    }
  
    public closePopUp(): void {
      this.isOpen = false;
      this.renderer.removeStyle(document.body, 'overflow');
    }

    public closeEstCuentaPopup(): void {
        this.isEstCuentPopUpOpen = false;
        this.renderer.removeStyle(document.body, 'overflow');
    }

  public sendPin() {
    this.errorFields = '';
    this.userDocId = this.userPinDocInput.getValue().replace(/-/g, '');
    if (this.userDocId[0] === '0') this.userDocId = this.userDocId.substring(1);
    this.validateDocPinInput(this.userDocId);

    try {
      this.authService.sendGeneratePin(this.userDocId).subscribe({
        next: (result: any) => {

          let m = result.ResponseMessages[0].Message;
          this.inputSendPin = '';

          this.closePopUp();
          this.pinCtDialog = this.plusAlertService.setCtDialogInfo('Pin de verificación enviado', 'success', 'success', 'primary', m,
            true, 'Finalizar', 'Cancelar', this.dialogContainer);

          this.managePopUpButtonActions();


        },
        error: (error: any) => {
          this.closePopUp();
          this.inputSendPin = '';
          console.log(error);
          this.pinCtDialog = this.plusAlertService.setCtDialogInfo('Pin de verificación no se pudo enviar ', 'error',
            'error', 'primary', error.description,
            true, 'Finalizar', 'Cancelar', this.dialogContainer);
          this.managePopUpButtonActions();
        }
      })
    } catch (error) { }

  }  


    private managePopUpButtonActions(): void {
        this.cdf.detectChanges();
        setTimeout(() => {         
            (this.pinCtDialog.getChildElements()[0] as CtButtonComponent).clickTimer.subscribe((ev : Event) => {
                this.pinCtDialog.closeDialog();
            });
        });
    }

    public resetPassword(): void {
        this.router.navigate(['/reset-password']);
    }

    public createAccount(): void {
        this.router.navigate(['/signup']);
    }

    public toggleSsmnContacts() : void {
        this.socialMediaVisiable = !this.socialMediaVisiable;
        this.cdf.detectChanges();
    }    

    getIsOpen(): boolean { return this.isOpen }
    getWidth(): number { return this.width }
    getCanBeClosed(): boolean { return this.canBeClosed }
    setIsOpen(isOpen: boolean): void { this.isOpen = isOpen }
    setCanBeClosed(canBeClosed: boolean): void { this.canBeClosed = canBeClosed }

}
